/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductApprovalCheckStepDto } from './ProductApprovalCheckStepDto';
export type ProductApprovalReleaseEngagementCheckStepDto = (ProductApprovalCheckStepDto & {
    state?: ProductApprovalReleaseEngagementCheckStepDto.state;
});
export namespace ProductApprovalReleaseEngagementCheckStepDto {
    export enum state {
        OPEN = 'OPEN',
        AVAILABLE_FOR_SIGNATURE = 'AVAILABLE_FOR_SIGNATURE',
        VERIFICATION_OF_SIGNATURE = 'VERIFICATION_OF_SIGNATURE',
        SIGNATURE_VERIFIED = 'SIGNATURE_VERIFIED',
    }
}

